export function parseAllowedEmails(raw: string | undefined | null): string[] {
    return String(raw || "")
        .split(",")
        .map((e) => e.trim().toLowerCase())
        .filter(Boolean);
}

/** When the dev domain gate is on, allow @domain plus exact extra emails. No email (SMS) is allowed. */
export function isEmailAllowedForDevGate(
    email: string | null | undefined,
    allowedDomain: string,
    allowedEmailsRaw: string | undefined | null,
): boolean {
    const normalized = String(email || "").trim().toLowerCase();
    if (!normalized) return true;
    const domain = (allowedDomain || "").trim().toLowerCase();
    const emailDomain = normalized.split("@")[1] || "";
    if (domain && emailDomain === domain) return true;
    return parseAllowedEmails(allowedEmailsRaw).includes(normalized);
}
